import { useEffect, useState } from 'react';
import { tiposEgresosService } from '../services/api';
import '../styles/Clientes.css';

const TiposEgresos = () => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    activo: true
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    cargarTipos();
  }, []);

  const cargarTipos = async () => {
    try {
      setLoading(true);
      const response = await tiposEgresosService.getTiposEgresos();
      setTipos(response.data.tipos_egresos || []);
    } catch (error) {
      console.error('Error al cargar tipos de egresos:', error);
      setError('Error al cargar tipos de egresos');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (tipo = null) => {
    if (tipo) {
      setEditingId(tipo.id);
      setFormData({
        nombre: tipo.nombre || '',
        descripcion: tipo.descripcion || '',
        activo: tipo.activo !== undefined ? tipo.activo : true
      });
    } else {
      setEditingId(null);
      setFormData({
        nombre: '',
        descripcion: '',
        activo: true
      });
    }
    setShowModal(true);
    setError('');
    setSuccess('');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({
      nombre: '',
      descripcion: '',
      activo: true
    });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      setLoading(true);

      if (editingId) {
        await tiposEgresosService.updateTipoEgreso(editingId, formData);
        setSuccess('Tipo de egreso actualizado correctamente');
      } else {
        await tiposEgresosService.createTipoEgreso(formData);
        setSuccess('Tipo de egreso creado correctamente');
      }

      handleCloseModal();
      await cargarTipos();
    } catch (error) {
      console.error('Error al guardar tipo de egreso:', error);
      setError(error.response?.data?.message || error.response?.data?.error || 'Error al guardar el tipo de egreso');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar este tipo de egreso?')) {
      return;
    }

    try {
      setLoading(true);
      await tiposEgresosService.deleteTipoEgreso(id);
      setSuccess('Tipo de egreso eliminado correctamente');
      await cargarTipos();
    } catch (error) {
      console.error('Error al eliminar tipo de egreso:', error);
      setError(error.response?.data?.message || error.response?.data?.error || 'Error al eliminar el tipo de egreso');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Cargando tipos de egresos...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>📝 Tipos de Egresos</h1>
        <button className="btn btn-primary" onClick={() => handleOpenModal()}>
          + Nuevo Tipo
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}
      {success && <div className="banner success">{success}</div>}

      {/* Tabla de Tipos */}
      <div className="card">
        <div className="card-title">
          Tipos de Egresos ({tipos.length})
        </div>

        {tipos.length === 0 ? (
          <p style={{padding: '2rem', textAlign: 'center', color: '#666'}}>
            No hay tipos de egresos registrados
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {tipos.map((tipo) => (
                  <tr key={tipo.id}>
                    <td>{tipo.id}</td>
                    <td style={{fontWeight: 'bold'}}>{tipo.nombre}</td>
                    <td>{tipo.descripcion || '-'}</td>
                    <td>
                      <span style={{
                        backgroundColor: tipo.activo ? '#27ae60' : '#95a5a6',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '0.85rem'
                      }}>
                        {tipo.activo ? 'ACTIVO' : 'INACTIVO'}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-icon"
                        title="Editar"
                        onClick={() => handleOpenModal(tipo)}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-icon"
                        title="Eliminar"
                        onClick={() => handleDelete(tipo.id)}
                        style={{marginLeft: '0.5rem'}}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal para crear/editar tipo de egreso */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingId ? 'Editar Tipo de Egreso' : 'Nuevo Tipo de Egreso'}</h2>
              <button className="modal-close" onClick={handleCloseModal}>×</button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Nombre *</label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    placeholder="Ej: Combustible"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="activo"
                      checked={formData.activo}
                      onChange={handleInputChange}
                      style={{marginRight: '0.5rem'}}
                    />
                    Activo
                  </label>
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label>Descripción</label>
                  <textarea
                    name="descripcion"
                    value={formData.descripcion}
                    onChange={handleInputChange}
                    placeholder="Descripción del tipo de egreso"
                    rows="3"
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Guardando...' : (editingId ? 'Actualizar' : 'Crear')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TiposEgresos;
